import {
    AfterViewInit,
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    HostListener,
    Input,
    signal,
    ViewChild,
    WritableSignal
} from '@angular/core';
import { ContentBlockComponent } from '../content-block/content-block.component';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';
import { SanitizeUrlPipe } from '../../pipes/sanitize-url.pipe';

@Component({
    selector: 'nw-youtube-block',
    imports: [ContentBlockComponent, SanitizeHtmlPipe, SanitizeUrlPipe],
    templateUrl: './youtube-block.component.html',
    styleUrl: './youtube-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class YoutubeBlockComponent implements AfterViewInit {
    @Input({ transform: booleanAttribute }) border: boolean = false;

    @Input() title?: string;
    @Input() topcontent?: string;
    @Input() bottomcontent?: string;
    @Input() youtubeid!: string;

    @ViewChild('iframe') iframe!: ElementRef;

    @HostListener('window:resize') windowResize(): void {
        this.resize();
    }

    public iframeHeight$$: WritableSignal<number> = signal(200);

    public ngAfterViewInit(): void {
        this.resize();
    }

    private resize(): void {
        this.iframeHeight$$.set(this.iframe?.nativeElement?.clientWidth * (9 / 16));
    }
}
